import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=36ef7486&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=ts&"
export * from "./DynamicForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef7486",
  null
  
)

export default component.exports